import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ar from './locales/ar.json';
import ru from './locales/ru.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  ru: { translation: ru },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      // Security note: escapeValue is disabled because React already escapes content.
      // Translation files (en.json, ar.json, ru.json) are developer-controlled and trusted.
      // If user-generated content were used in translations, this would need to be true.
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Function to get text direction based on language
export const getDirection = (lang) => {
  return lang === 'ar' ? 'rtl' : 'ltr';
};

// Function to get font family based on language
export const getFontFamily = (lang) => {
  switch (lang) {
    case 'ar':
      return "'Noto Sans Arabic', 'Inter', sans-serif";
    case 'ru':
      return "'Inter', sans-serif";
    default:
      return "'Inter', sans-serif";
  }
};

export default i18n;
